export default {
	"Card.Online": "Online",
	"Card.Hot": "Hot",
	"Card.SoldOutSoon": "Sold out soon",
	"Card.SnappingUp": "Snapping up",
	"Card.OffTheEnd": "Off the end",
	"Card.ComingSoon": "Coming soon",
	"Card.sky": "sky",
	"Card.Sold": "Sold",
	"Card.SnapItUpNow": "Snap it up now",
	"Card.MarketingMallComponentClick": "Marketing Mall_Component click",
	"Card.MarketingMarketplace": "Marketing Marketplace",
	"Card.AListOfStoreItems": "A list of store items",
	"Card.StoreResourceBits": "Store resource bits",
	"Card.More": "More >"
}